import { render, staticRenderFns } from "./Hover5.vue?vue&type=template&id=686f88a3&scoped=true&"
import script from "./Hover5.vue?vue&type=script&lang=js&"
export * from "./Hover5.vue?vue&type=script&lang=js&"
import style0 from "./Hover5.vue?vue&type=style&index=0&id=686f88a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686f88a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VCard,VRating})
